export const DEFAULT_REGISTER_FORM = {
	'id': null, // 活动id
	'type': null, // 活动类型
	'userName': null, // 用户名
	'lastName': null, // 姓
	'firstName': null, // 名
	'landAreaCode': '+86', // 地区码
	'occupation': null, // 职业
	'email': null, // 邮箱
	'landlineNumber': null, // 座机号
	'supportReviewType': null, // 支持审核类型
	'isOnlyEmailUser': null, // 是否只有邮箱用户
	'cropBusinessCard': null, // 裁剪名片
	'preQuestion': null, // 预问答
	'languageType': null, // 语言类型
	'needCallOut': 0, // 是否需要外呼
	'conditionInfos': [], // 条件信息
	'signPath': null, // 签名路径
	'cardInfo': {
		'telephone': null, // 电话
		'email': null, // 邮箱
		'workTelAreaCode': null, // 工作电话地区码
		'address': null, // 地址
		'name': null, // 姓名
		'department': null, // 部门
		'telAreaCode': null, // 电话地区码
		'position': null, // 职位
		'companyEn': null, // 公司英文名
		'workTel': null, // 工作电话
		'company': null, // 公司
		'requestId': null // 名片识别ID
	},
	'registerSource': null, // 注册来源
	'areaCode': '+86', // 地区码
	'organizationNameEn': null, // 公司英文名
	'entourageInfos': [], // 随行人员信息
	'companyName': null, // 公司名
	'subLandlineNumber': null, // 分机号
	'businessCard': null, // 名片
	'regionalCode': null, // 区域码
	'phoneNumber': null, // 电话
	'department': null, // 部门
	'registerId': null, // 注册id
	'isAgentRegister': null,
	'businessCardId': null // 名片识别ID

};

export const TAB_MAP = {
	'-1': '免登录',
	0: '机构投资者',
	1: '个人投资者',
	2: '其他机构',
	3: '腾讯会议',
	4: 'ZOOM会议'
};

export const OUTGOING_CALL_SETTINGS = {
	'conditionName': '是否外呼',
	'isRequired': 1,
	'isShow': 1,
	'langEn': {
		'conditionName': 'Call-in required'
	},
	'langZhHK': {
		'conditionName': '是否外呼'
	},
	'name': 'needCallOut'
};
export const OUTBOUND_CALL_LANDLINE_SETTINGS = {
	'conditionName': '备用号码',
	'isRequired': 0,
	'isShow': 1,
	'langEn': {
		'conditionName': 'Alt. Tel.'
	},
	'langZhHK': {
		'conditionName': '備用號碼'
	},
	'name': 'isQutboundCallLandline'
};

// 基础信息的字段，需要写入conditionsInfos
export const BASE_INFO_FIELDS = [
	'userName',
	'lastName',
	'firstName',
	'occupation',
	'email',
	'companyName',
	'phoneNumber',
	'preQuestion',
	'businessCard',
	'department'
];
